import AccountTransferForm from './AccountTransferForm'

export default AccountTransferForm
